<template>
  <div class="contact-us-index" @mouseenter="hasdashed=true"
      @mouseleave="hasdashed=false">
  <div
    class="backtop-mask"
    v-if="isShowEdit"
    @click="isShowEdit = false"
  ></div>
    <div class="contact-us-wrapper" 
      
      :style="{border: hasdashed && $store.state.app.view_pattern === 'pc' ? '1px dashed #333' : ''}">
      <div class="edit_cont" v-if="$store.state.app.view_pattern === 'pc'">
        <span class="sys_icon el-icon-edit" :title="$t('view_back_top_index_104')" @click="showEditModule"></span>
        <span class="sys_icon el-icon-view" :title="$t('view_back_top_index_105')" @click="hiddeEditModule"></span>
      </div>
      <div class="contact-us-content" @dblclick="showEditModule">
        <set_link class="linkPart" :sendData="listArr.link"></set_link>
        <div class="contact-us icon-default" v-if="contact_us_set.radio_val == 'default'" :style="{
         ...default_style
        }">
        </div>
        <div class="contact-us"  v-else>
          <img :src="contact_us_set.customSet.url" alt="" class="us-img">
        </div>
      </div>
    </div>
    <contactUsEdit
      v-if="isShowEdit"
      :iconList="iconList"
      @changeIcon="iconStyleChange"
      @changeShow="isShowEdit = false"
    ></contactUsEdit>
  </div>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

import contactUsEdit from './edit'
export default {
  name: 'contact_us_index',
  data(){
    return {
      iconList: [
        {
          id: 'default-0',
          borderRadius: '50%',
          canChangeColor: true,
          backgroundColor: 'rgba(55, 85, 239, 1)',
          iconPosition: '-0 -0'
        },
        {
          id: 'default-1',
          borderRadius: '6px',
          canChangeColor: true,
          backgroundColor: 'rgba(55, 85, 239, 1)',
          iconPosition: '-49px -0'
        },
        {
          id: 'default-2',
          borderRadius: '50%',
          canChangeColor: true,
          backgroundColor: 'rgba(55, 85, 239, 1)',
          iconPosition: '-98px -0'
        },
        {
          id: 'default-3',
          borderRadius: '6px',
          canChangeColor: true,
          backgroundColor: 'rgba(55, 85, 239, 1)',
          iconPosition: '-147px -0'
        },
        {
          id: 'default-4',
          borderRadius: '50%',
          canChangeColor: true,
          backgroundColor: 'rgba(55, 85, 239, 1)',
          iconPosition: '-196px -0'
        },
        {
          id: 'default-5',
          borderRadius: '0',
          canChangeColor: false,
          backgroundColor: 'rgba(55, 85, 239, 1)',
          iconPosition: '-245px -0'
        },
        {
          id: 'default-6',
          borderRadius: '0',
          canChangeColor: false,
          backgroundColor: 'rgba(55, 85, 239, 1)',
          iconPosition: '-294px -0'
        },
        { 
          id: 'default-7',
          borderRadius: '0',
          canChangeColor: false,
          backgroundColor: 'rgba(55, 85, 239, 1)',
          iconPosition: '-343px -0'
        },
        
      ],
      isShowEdit: false,
      hasdashed:false,
    }
  },
  mounted() {
    if(this.contact_us_set.radio_val == 'custom'){
      this.contact_us_set.radio_val = 'customSet'
    }
    if(this.contact_us_set.custom) {
     this.contact_us_set.customSet = this.contact_us_set.custom
     delete this.contact_us_set.custom
    }
  },
  computed: {
    listArr() {
      return  this.$store.state.myRender.common.contact_us.listArr
    },
    contact_us_set() {
      return  this.$store.state.myRender.common.contact_us.contact_us_set
    },
    contact_us_data() {
      return this.contact_us_set[this.contact_us_set.radio_val]
    },
    default_style(){
      let style = {
        backgroundPosition: this.contact_us_data.iconPosition,
        borderRadius: this.contact_us_data.borderRadius
      }
      
      if(this.contact_us_data.canChangeColor) {
        style.backgroundColor= this.contact_us_data.backgroundColor
      }
      // console.log(this.contact_us_data,8888, style)
      return style
    }
  },
  methods: {
    showEditModule() {
      this.isShowEdit = true
      this.hasdashed = false
    },
    hiddeEditModule() {
      // this.isShowEdit
      this.$store.commit('myRender/set_contact_us_show', false);
    },
    iconStyleChange() {
      
    }
  },
  components: {
    contactUsEdit
  }
};
</script>

<style scoped lang="scss">
.contact-us-index {
  position: fixed;
  bottom:130px;
  right:21px;
  height:70px;
  width:66px;
  // border: 1px solid red;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2002;
  .backtop-mask {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }
  .contact-us-wrapper{
    width:66px;
    height:70px;
    display: flex;
    justify-content: center;
    align-items: center;
    .edit_cont {
      position: absolute;
      display: none;
      right: 0;
      top: -24px;
      font-size: 0;
      .sys_icon {
        display: inline-block;
        vertical-align: top;
        width: 24px;
        height: 24px;
        color: #fff;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        background-color: #444;
        cursor: pointer;
        &:hover {
          background-color: #222;
        }
      }
    }
    
    .contact-us-content{
      width:49px;
      height:49px;
      .contact-us{
        width:49px;
        height:49px;

        cursor:pointer;
        &.icon-default{
          background-image:url("~@/assets/image/contact_us_icon.png");
        }
      }
    }
  }
  &:hover {
    .edit_cont {
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/contact_us/index.vue